import "admin/src/style/videoMetadataPage.css";
import { KeyboardKey } from "assets/js/enums/keyboard.enum";
import { _ } from "i18n";
import type { ReactNode } from "react";
import { useState } from "react";
import Modal from "ui-kit/src/Modal";
import { RenameModal } from "./RenameModal";

interface RenameVideoButtonProps {
	videoId: number;
	currentName: string;
	className?: string;
	/** Defaults to the Edit Name text used in table action cells. */
	label?: ReactNode;
}

export function RenameVideoButton({
	videoId,
	currentName,
	className = "actionsButton",
	label,
}: RenameVideoButtonProps) {
	const [showModal, setShowModal] = useState(false);
	const editNameLabel = _("admin.video.actions.editName");

	return (
		<>
			<span
				className={className}
				role="button"
				tabIndex={0}
				title={editNameLabel}
				aria-label={editNameLabel}
				onClick={() => setShowModal(true)}
				onKeyDown={(event) => {
					if (event.key === KeyboardKey.Enter || event.key === KeyboardKey.Space) {
						event.preventDefault();
						setShowModal(true);
					}
				}}
			>
				{label ?? editNameLabel}
			</span>
			<Modal show={showModal} onClose={() => setShowModal(false)} size="sm" title={editNameLabel}>
				{/* Mounted only while open so the input always re-initialises from the latest name. */}
				{showModal && (
					<RenameModal
						videoId={videoId}
						currentName={currentName}
						close={() => setShowModal(false)}
					/>
				)}
			</Modal>
		</>
	);
}
